import styled from 'styled-components';
import { DoubleArrow } from 'ui/icons/navigation/DoubleArrow';
import { UpArrow } from 'ui/icons/navigation/UpArrow';
import { DownArrow } from 'ui/icons/navigation/DownArrow';
import { button, spacing, colors } from 'ui/theme';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

type ButtonProps = {
  isActive: boolean;
};

export const Button = styled.button`
  ${button}
  align-items: center;
  background: none;
  border: none;
  color: ${(props: ButtonProps) => (props.isActive ? colors.purple100 : 'inherit')};
  cursor: 'pointer';
  display: flex;
  padding: ${spacing.half} 0;
  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

export type Props = {
  label: string;
  name: string;
  onClick: (name: string) => void;
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
};

export const SortableHeaderCell = ({ label, name, onClick, sortBy, sortDirection }: Props) => {
  const isActive = sortBy === name;
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;
  const color = isActive ? colors.purple100 : colors.grey50;

  return (
    <Button isActive={isActive} onClick={() => onClick(name)}>
      <span>{label}</span>
      {!isActive && <DoubleArrow color={color} />}
      {isActive && isAscending && <UpArrow color={color} />}
      {isActive && !isAscending && <DownArrow color={color} />}
    </Button>
  );
};
